import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";
import { useHistory } from "react-router-dom";

const InfoPromotion = props => {
	const classes = useStyles();
	const { product } = props;
	const history = useHistory();

	const rewardDiscounts = product?.promotionDetails?.rewardDiscounts;
	const rewardGifts = product?.promotionDetails?.rewardGifts;

	const renderTextGift = (isAllProduct, product) => {
		return isAllProduct ? (
			<React.Fragment>
				Mua từ{" "}
				{product?.totalQuantity || formatCash(product?.totalAmount)}{" "}
				<span style={{ textTransform: "lowercase" }}>
					{product?.totalQuantity ? product?.unit || "lẻ" : "đ"}
				</span>{" "}
				được tặng{" "}
				{product?.promotionGifts?.map((promotion, index) => {
					return (
						<React.Fragment key={index}>
							<span>{index > 0 ? " và" : ""}</span>
							<span style={{ color: "#F84F06" }}>
								{" "}
								{promotion?.quantity} {promotion?.productsName}
							</span>
						</React.Fragment>
					);
				})}
			</React.Fragment>
		) : (
			<React.Fragment>
				Mua từ{" "}
				{product?.productConditions?.map((productCondition, index) => {
					return (
						<React.Fragment key={index}>
							<span>{index > 0 ? " và" : ""}</span>
							<span>
								{" "}
								{productCondition?.quantity ||
									formatCash(productCondition?.amount)}{" "}
								<span style={{ textTransform: "lowercase" }}>
									{productCondition?.unit || "đ"}
								</span>{" "}
								{productCondition?.name}
							</span>
						</React.Fragment>
					);
				})}{" "}
				được tặng{" "}
				{product?.promotionGifts?.map((promotion, index) => {
					return (
						<React.Fragment key={index}>
							<span>{index > 0 ? " và" : ""}</span>
							<span style={{ color: "#F84F06" }}>
								{" "}
								{promotion?.quantity} {promotion?.productsName}
							</span>
						</React.Fragment>
					);
				})}
			</React.Fragment>
		);
	};

	const renderTextDiscounts = (isAllProduct, product) => {
		const isConditionAmount = product?.productConditions?.every(
			product => !!product?.amount
		);
		return isAllProduct ? (
			<React.Fragment>
				Mua từ{" "}
				{product?.totalQuantity || formatCash(product?.totalAmount)}{" "}
				<span style={{ textTransform: "lowercase" }}>
					{product?.unit || "đ"}{" "}
				</span>{" "}
				được tặng{" "}
				<span style={{ color: "#F84F06" }}>
					chiết khấu {product?.discount}%
				</span>
			</React.Fragment>
		) : (
			<React.Fragment>
				{isConditionAmount ? (
					<React.Fragment>
						Mua đơn hàng có giá trị ít nhất từ{" "}
						{product?.productConditions?.map(
							(productCondition, index) => {
								return (
									<React.Fragment key={index}>
										<span>{index > 0 ? " và" : ""}</span>
										<span>
											{" "}
											{formatCash(
												productCondition?.amount
											)}{" "}
											đ với sản phẩm{" "}
											{productCondition?.name}
										</span>
									</React.Fragment>
								);
							}
						)}{" "}
						được tặng{" "}
						<span style={{ color: "#F84F06" }}>
							chiết khấu {product?.discount}%
						</span>
					</React.Fragment>
				) : (
					<React.Fragment>
						Mua từ{" "}
						{product?.productConditions?.map(
							(productCondition, index) => {
								return (
									<React.Fragment key={index}>
										<span>{index > 0 ? " và" : ""}</span>
										<span>
											{" "}
											{productCondition?.quantity ||
												formatCash(
													productCondition?.amount
												)}{" "}
											<span
												style={{
													textTransform: "lowercase"
												}}
											>
												{productCondition?.unit || "đ"}
											</span>{" "}
											{productCondition?.name}
										</span>
									</React.Fragment>
								);
							}
						)}{" "}
						được tặng{" "}
						<span style={{ color: "#F84F06" }}>
							chiết khấu {product?.discount}%
						</span>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	};

	return (
		<Grid container classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.border }} />
			{rewardGifts?.conditionRewards?.length > 0 &&
				rewardGifts?.conditionRewards?.map(product => (
					<Grid
						classes={{ root: classes.btnPromotion }}
						key={product?.level}
					>
						<Grid classes={{ root: classes.borderLeft }} />
						<Grid container spacing={1} alignItems="center">
							<Grid item xs={3}>
								<Grid classes={{ root: classes.promotion }}>
									KM{product?.level || ""}
								</Grid>
							</Grid>
							<Grid item xs={9} style={{ lineHeight: "20px" }}>
								{renderTextGift(
									rewardGifts?.isAllProduct,
									product
								)}
							</Grid>
						</Grid>
						<Grid classes={{ root: classes.borderRight }} />
					</Grid>
				))}

			{rewardDiscounts?.conditionRewards?.length > 0 && (
				<React.Fragment>
					<Grid classes={{ root: classes.titleDiscount }}>
						<Grid classes={{ root: classes.line }} />
						<Grid classes={{ root: classes.title }}>
							Và được tặng chiết khấu theo hạng mức
						</Grid>
						<Grid classes={{ root: classes.line }} />
					</Grid>
					{rewardDiscounts?.conditionRewards?.map(product => (
						<Grid
							classes={{ root: classes.btnPromotion }}
							key={product?.level}
						>
							<Grid classes={{ root: classes.borderLeft }} />
							<Grid container spacing={1} alignItems="center">
								<Grid item xs={3}>
									<Grid classes={{ root: classes.discount }}>
										CK{product?.level || ""}
									</Grid>
								</Grid>
								<Grid
									item
									xs={9}
									style={{ lineHeight: "20px" }}
								>
									{renderTextDiscounts(
										rewardDiscounts?.isAllProduct,
										product
									)}
								</Grid>
							</Grid>
							<Grid classes={{ root: classes.borderRight }} />
						</Grid>
					))}
				</React.Fragment>
			)}
			<Grid classes={{ root: classes.note }}>
				Khuyến mãi sẽ tự động áp dụng tại giỏ hàng của bạn
			</Grid>
			<Grid
				classes={{ root: classes.promotionDetail }}
				onClick={() => {
					history.push(`/promotion_detail?id=${product?.campaignId}`);
				}}
			>
				Chi tiết khuyến mãi
			</Grid>
		</Grid>
	);
};
export default memo(InfoPromotion);
